module.exports = __webpack_public_path__ + "img/buses.7a511cdf.jpg";